// extracted by mini-css-extract-plugin
export var content = "_ng-1";
export var noScroll = "_ng-3";
export var paper = "_ng-0";
export var scrollable = "_ng-2";